import type { ApuIaConcepto, ApuIaMatrix } from '../api/apuIa.js';
import type { getPlanoRenglonApu } from '../api/planos.js';

type ApuDeRenglon = Awaited<ReturnType<typeof getPlanoRenglonApu>>;

/**
 * Arma, con el análisis de un renglón de planos, el ApuIaConcepto que usan los render compartidos
 * con la cotización (vista del análisis e impresión): subtotales del desglose + razonamiento/
 * factores/alertas/preguntas que viven en la matriz + validaciones/razón del semáforo.
 */
export function conceptoDeApuDeRenglon(
  r: ApuDeRenglon,
  renglon?: { id: string; clave: string | null; cantidad: number; importe: number | null },
): ApuIaConcepto {
  const d = r.desglose ?? {};
  const matrix = (r.matrix as ApuIaMatrix) ?? null;
  return {
    id: renglon?.id,
    clave: renglon?.clave ?? null,
    descripcion: r.descripcion,
    unidad: r.unidad,
    cantidad: renglon?.cantidad ?? null,
    apu_ia_importe: renglon?.importe ?? null,
    apu_ia_matrix: matrix,
    apu_ia_costo_directo: r.costoDirecto ?? d.costoDirecto ?? null,
    apu_ia_rendimiento_base: r.rendimientoBase ?? matrix?.rendimiento_base ?? null,
    // Con los factores de obra del proyecto; null = análisis anterior a ellos (la vista usa el base).
    apu_ia_rendimiento_ajustado: r.rendimientoAjustado ?? null,
    apu_ia_sub_materiales: d.subMateriales ?? null,
    apu_ia_sub_mo: d.subMo ?? null,
    apu_ia_sub_equipo: d.subEquipo ?? null,
    apu_ia_sub_herramienta: d.subHerramienta ?? null,
    apu_ia_sr_cuadrilla: d.srCuadrilla ?? null,
    apu_ia_factores_aplicados: matrix?.factores_aplicados ?? null,
    apu_ia_alertas: matrix?.alertas_levantadas ?? null,
    apu_ia_preguntas_pendientes: matrix?.preguntas_pendientes ?? null,
    apu_ia_validaciones: d.validaciones ?? null,
    apu_ia_confianza_semaforo: (r.confianza as 'green' | 'yellow' | 'red' | null) ?? null,
    apu_ia_confianza_razon: d.confianzaRazon ?? null,
  } as unknown as ApuIaConcepto;
}
